// Rutas de Activos (catálogo v26: `app:activos` con `routes: ["/activos"]` y los
// menús `menu:activos.{inventario,compras,proveedores}`). Cada sección vive en
// `/activos/<id del menú>`, la convención que usan las guardias de menú.
export const ACTIVOS_APP_ID = "activos";
export const ACTIVOS_CATEGORY_ID = "bases-y-propiedades";
export const ACTIVOS_BASE = "/activos";

/**
 * El gasto de una compra en Gastos (PR 4). Sólo se enlaza si la persona tiene
 * acceso a Finanzas (`GET /expensesAccess`); la lista de gastos lo abre por su id.
 */
export const expensePath = (expenseId: string) => `/expenses/expenses?expense=${encodeURIComponent(expenseId)}`;

/** Dispositivos de rastreo (D1: los GPS no son activos; se administran ahí). */
export const DEVICES_ROUTE = "/admin/devices";
